export interface IProviderProfilePicture {
  id: string;
  path: string;
  url: string;
  imageData: string;
  name: string;
}

export interface Address {
  street: string;
  city: string;
  zipCode: string;
  country: string;
}

export interface ProviderCategory {
  id: number;
  name: string;
  slug: string;
}

export interface ProviderSubcategory {
  id: number;
  name: string;
}

export interface WeekDay {
  from: string;
  to: string;
}

export interface WeekDays {
  [key: string]: WeekDay[];
}

export interface OpeningHours {
  description: string;
  weekdays?: WeekDays;
  validation?: { hasError: boolean };
}

export interface Language {
  enableLanguageSelection: boolean;
  primaryLanguage: string;
  secondaryLanguages: string[];
}

export interface ProviderAccess {
  name: string;
  accessType?: ProviderAccessType;
}
export enum ProviderAccessType {
  FULL = 'Full',
  PARTNER_TOOL = 'PartnerTool',
}

export enum OrganisationAccessType {
  FULL = 'Full',
  PARTNER_TOOL = 'PartnerTool',
}

export interface Provider {
  uuid: string;
  name: string;
  domain: string;
  officialName: string;
  address: Address;
  website: string | null;
  email: string;
  phone: string;
  foundingYear: string;
  employeeCount: number;
  latitude: number;
  longitude: number;
  studioSize: string;
  providerCategoryId: number;
  providerCategory: ProviderCategory;
  providerSubcategories: ProviderSubcategory[];
  coverUrl: string;
  coverOriginalUrl: string;
  coverUrlSmall: string;
  logoUrl: string;
  logoOriginalUrl: string;
  galleryUrls: string[];
  featureIds: number[];
  activityCategoryIds: number[];
  openingHours: OpeningHours;
  weightedAverageRating: number;
  isPublished: boolean;
  intervieweeAvatar: string;
  interviewText: string;
  intervieweeName: string;
  parentId: number;
  onboardingStatus: number;
  timeZoneId: string;
  brandColor: string;
  googleAnalyticsId: string;
  showCancelledEvents: boolean;
  showEventColors: boolean;
  showFreeSeats: boolean;
  offersEnabled: boolean;
  checkoutShowAddress: boolean;
  checkoutAddressMandatory: boolean;
  checkoutShowPhone: boolean;
  checkoutShowBirthdate: boolean;
  checkoutPhoneMandatory: boolean;
  checkoutBirthdateMandatory: boolean;
  defaultPaymentType: string;
  language: Language;
  currencyId: number;
  showEventListPage: boolean;
  impressText: string;
  commercialRegisterName: string;
  commercialRegisterNumber: string;
  vatNum: string;
  ceoName: string;
  termsUrl: string;
  privatePolicyUrl: string;
  favIconImageUrl: string;
  studioPageEnabled: boolean;
  ownerId: string;
  isUSCMember: boolean;
  isOneFitMember: boolean;
  accessType: ProviderAccessType;
  organisationId?: string;
  organisationVenueId?: number;
}

export interface ProviderPatch {
  provider: Partial<Provider>;
}
